/* eslint-disable
    no-unused-vars,
    react/prefer-stateless-function,
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import {assert} from 'Asserts';
import * as StepConstants from 'notebook/protocols/StepConstants';

const {EditorKey} = StepConstants;

import PropTypes from 'prop-types';

import EditableComponent from 'notebook/mediocre/core-ui/EditableComponent';
import EditableList from 'notebook/mediocre/selection/text/EditableListMixin';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';

class IntroEditable extends React.Component {
  static propTypes = {
    cid: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    locked: PropTypes.bool,
    spellCheck: PropTypes.bool.isRequired,
  };

  render() {
    return (
      <EditableComponent
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          allowRichText: true,
          allowMultiline: true,
          spellCheck: this.props.spellCheck,
        })}
      />
    );
  }
}

const IntroEditor = createReactClass({
  propTypes: {
    protocol: PropTypes.object.isRequired,
    jumpTo: PropTypes.func.isRequired,
    updateProtocol: PropTypes.func, // omitted if locked
    spellCheck: PropTypes.bool.isRequired,
  },

  mixins: [EditableList],

  getIntro() {
    return this.props.protocol.description;
  },

  setIntro(text, formats) {
    assert(text != null && formats != null, 'You must set intro and formats together');
    this.props.updateProtocol({
      description: text,
      descriptionFormats: formats,
    });
  },

  moveHandler(e) {
    const {up, beginning} = e;
    this.clearSelection();
    const location = beginning ? 'start' : 'end';
    const row = up ? 'last' : 'first';
    const section = up ? EditorKey.TITLE : EditorKey.MATERIALS;
    this.props.jumpTo({section, location, row});
  },

  updateHandler(e) {
    const {text, formats, target} = e;
    this.setIntro(text, formats);
    this.props.requestSelection({selection: selutil.getSelectionIndices(e)});
  },

  pasteHandler(e) {
    let part;
    const {before, selected, after, originalEvent} = e;
    const parts = wyciwyp.processClipboard(originalEvent.clipboardData);
    const oldFormats = this.props.protocol.descriptionFormats;
    const beforeFormats = formatters.splitFormats(oldFormats, before.length).before;
    const afterFormats = formatters.splitFormats(oldFormats, before.length + selected.length).after;

    const text =
      before +
      (() => {
        const result = [];
        for (part of Array.from(parts)) {
          result.push(part.text);
        }
        return result;
      })().join('\n') +
      after;
    let offset = before.length;
    let newFormats = beforeFormats;
    for (let i = 0; i < parts.length; i++) {
      part = parts[i];
      newFormats = formatters.joinFormats(newFormats, part.formats, offset);
      offset += part.text.length;
      if (i !== parts.length - 1) {
        offset += 1; // for the new line
      }
    }

    newFormats = formatters.joinFormats(newFormats, afterFormats, offset);
    const pos = text.length - after.length;
    this.setIntro(text, newFormats);
    this.props.requestSelection({selection: {cid: this.props.cid, start: pos, end: pos}});
  },

  splitHandler(e) {
    const {before, selected, after, cursor} = e;
    const oldFormats = this.props.protocol.descriptionFormats;
    const beforeFormats = formatters.splitFormats(oldFormats, before.length).before;
    const afterFormats = formatters.splitFormats(oldFormats, before.length + selected.length).after;
    const text = `${before}\n${after}`;
    const newFormats = formatters.joinFormats(beforeFormats, afterFormats, before.length + 1);
    const pos = before.length + 1;
    this.setIntro(text, newFormats);
    this.props.requestSelection({selection: {cid: this.props.cid, start: pos, end: pos}});
  },

  getInitialState() {
    return {
      index: 0,
    };
  },

  render() {
    return (
      <div className="intro-editor" data-editor={this.props.editorKey}>
        <IntroEditable
          cid={this.props.cid}
          text={this.props.protocol.description}
          index={this.state.index}
          formats={this.props.protocol.descriptionFormats}
          formatHandler={this.props.formatHandler.bind(null, this.state.index)}
          moveHandler={this.moveHandler}
          updateHandler={this.updateHandler}
          pasteHandler={this.pasteHandler}
          splitHandler={this.splitHandler}
          storeState={this.props.storeState}
          restoreState={this.props.restoreState}
          locked={this.props.locked}
          spellCheck={this.props.spellCheck}
        />
      </div>
    );
  },
});

export default IntroEditor;
